import Vue from 'vue';
import Vuex from 'vuex';
import MapStore from '@/store/MapStore';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    map: MapStore,
  },
  getters: {
    mapCenter: (state) => state.map.center,
    mapBounds: (state) => state.map.bounds,
    mapFilterOpen: (state) => state.map.filter.open,
    mapFilterDelivery: (state) => state.map.filter.delivery,
    mapFilterPickup: (state) => state.map.filter.pickup,

    isAddModeEnable: (state) => state.map.isAddModeEnable,
  },
});
